import { Text } from "@ecco/ui/text";
import type { PropsWithChildren } from "react";
import { summaryStyles } from "./CheckoutStyles";

type Props = PropsWithChildren<{
    /**
     * If true, adds spacing below the headline
     */
    spacing?: boolean;
}>;

export const SummarySectionHeadline = ({ children, spacing = true }: Props) => {
    return (
        <Text mb={spacing ? 3 : 0} {...summaryStyles.summaryHeadline}>
            {children}
        </Text>
    );
};
